import { Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  rowsCount: number;
  page: number;
  rowsPerPage: number;
  testIdPrefix?: string;
}

export const DisplayedRows = memo(({ rowsCount: count, page, rowsPerPage, testIdPrefix }: Props) => {
  const { t } = useTranslation();

  const labelDisplayedRowsTo = useMemo(() => {
    const adjustedPage = page - 1;

    if (count === -1) {
      return (adjustedPage + 1) * rowsPerPage;
    }
    return rowsPerPage === -1 ? count : Math.min(count, (adjustedPage + 1) * rowsPerPage);
  }, [count, page, rowsPerPage]);

  const label = useMemo(() => {
    const adjustedPage = page - 1;

    const from = count === 0 ? 0 : adjustedPage * rowsPerPage + 1;
    const to = labelDisplayedRowsTo;
    const labelCount = count === -1 ? -1 : count;

    return `${from}–${to} ${t('common.outOf')} ${labelCount !== -1 ? labelCount : `more than ${to}`}`;
  }, [count, labelDisplayedRowsTo, page, rowsPerPage, t]);

  return (
    <Typography data-testid={testIdPrefix ? `${testIdPrefix}-pagination-range` : 'pagination-range'} sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
      {label}
    </Typography>
  );
});
